import React, { useEffect, useState } from 'react'
import PlusIcon from '../../../../components/elements/icons/PlusIcon'
import ModalDialog from '../../../../components/layouts/ModalDialog'
import CreateAssessment from '../../../../components/partials/assessments/CreateAssessment'
import SearchField from '../../../../components/elements/SearchField'
import { useDispatch, useSelector } from 'react-redux'
import Loader from '../../../../components/elements/Loader'
import Pagination from '../../../../components/elements/Pagination'
import EmptyState from '../../../../components/elements/EmptyState'
import TrashIcon from '../../../../components/elements/icons/TrashIcon'
import { Link } from 'react-router-dom'
import ArrowIcon from '../../../../components/elements/icons/ArrowIcon'
import { fetchAssessments } from '../../../../store/actions/assessmentsActions'
import moment from 'moment'
import AssessmentsFilters from '../../../../components/elements/filters/AssessmentsFilters';

const Assessments = () => {
  const [reload, setReload] = useState(0)
  const [page, setPage] = useState(1)
  const [perPage, setPerPage] = useState(25)

  const dispatch = useDispatch()
  const assessmentsSelector = useSelector(state => state.assessments)
  const [filters, setFilters] = useState('')
  
  useEffect(() => {
    dispatch(fetchAssessments(filters, page, perPage))

    if(assessmentsSelector.createdAssessment !== null){
      setCreatingAssessment(false)
    }
  
    return () => {
      
    }
  }, [dispatch, page, perPage, filters, reload, assessmentsSelector.createdAssessment])
  
  const doDelete = (id) => {

  }

  const [creatingAssessment, setCreatingAssessment] = useState(false)

  return (
    <>
      <div className='w-full'>
        <div className="w-full mx-auto flex items-center justify-between">
          <div className='w-8/12'>
              <h4 className='font-medium text-lg mb-3 text-gray-600'>Continuous Assessments</h4>
              <div className='w-2/3'>
                  <p className='text-gray-500 my-3 text-sm'>
                      Set up continuous assessments for the college here. All assessment records will be created against these assessments here. You can click on an assessment to see more details and create assessment records.
                  </p>
              </div>
          </div>
          <div className='w-4/12 flex flex-row-reverse'>
              <button onClick={()=>{setCreatingAssessment(true)}} className='rounded px-4 py-3 mt-4 text-sm text-purple-100 bg-vcm-purple transition duration-200 border border-vcm-purple hover:bg-vcm-light-purple hover:text-vcm-purple flex items-center justify-center gap-x-2'>
                  <PlusIcon className='w-5 h-5' /> Create Assessment
              </button>
          </div>
        </div>

        <div className='w-full flex items-center justify-between my-5 p-2 rounded-md border'>
          <div className='w-full'>
            <AssessmentsFilters  
              applyFilters={(filter)=>{setFilters(filter)}}
            />
          </div>
          {/* <div className='w-4/12 flex flex-row-reverse gap-x-2'>
            <button onClick={()=>{}} className={`text-gray-700 px-3 py-2 hover:bg-gray-100 transition duration-200 text-sm flex items-center justify-center gap-x-2 bg-gray-200 rounded border`}>
              <ArrowUpTrayIcon className={`w-5 h-5`} />
              Export Subjects List
            </button>
          </div> */}
          <div className='w-5/12'>
              <SearchField 
                placeholderText={`Search for assessment`}
                showResultsDropDown={false}
                triggerSearch={(term)=>{}}
                performingSearch={false}
              />
          </div>
        </div>

        {assessmentsSelector?.fetchingAssessments ? 
          <Loader />
          :
          <>
            {assessmentsSelector?.assessments?.assessments?.length > 0 ? 
              <div className=''>
                  <>
                    <div className='mt-8 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-1'>
                      {assessmentsSelector?.assessments?.assessments?.map((assessment, assessmentIndex)=>(
                        <div key={assessmentIndex} className='w-full p-[40px] rounded bg-gray-50'>
                          <p className='font-space-grotesk font-[550]'>{assessment.name}</p>
                          <p className='text-sm text-gray-700 mt-[5px] mb-[20px]'>{assessment.description.slice(0,150)}{assessment.description.length > 150 ? '...' : ''}</p>

                          <div className="my-4 flex items-start justify-between">
                            <div>
                              <p className='text-xs font-medium text-gray-500'>Type</p>
                              {assessment.type==='continuous-assessment' ? <span className='px-[10px] py-[5px] inline-block rounded bg-yellow-500 text-yellow-800 bg-opacity-10 text-xs font-medium font-space-grotesk'>
                                Continuous Assessment
                              </span>
                              :
                              <span className='px-[10px] py-[5px] inline-block rounded bg-green-500 text-green-800 bg-opacity-10 font-medium font-space-grotesk text-xs'>
                                Term Examination
                              </span>
                              }
                            </div>
                            <div className="text-right p-3 bg-gray-100 rounded">
                              <p className='text-xs font-medium text-gray-500'>Total Marks</p>
                              <p className='text-lg font-space-grotesk font-semibold text-gray-800'>{assessment.totalMarks}</p>
                            </div>
                        </div>

                          <div className='mt-[20px]'>
                            <p className='text-sm font-medium text-gray-600'>{assessment.term.name} - {assessment.academicSession.name}</p>
                            <p className='text-sm mt-[5px] font-medium text-gray-800'>From {moment(assessment.dates.from).format('LL')} to {moment(assessment.dates.to).format('LL')}</p>

                          </div>
                          <div className="w-full flex items-center justify-between mt-5 border-t pt-3">
                            <Link to={assessment._id} className='text-sm flex flex-row items-center gap-x-2 text-vcm-purple hover:text-gray-400 transition duration-200'>View Assessment Details<ArrowIcon className={`w-4 h-4`} /></Link> 

                            <button onClick={()=>{doDelete(assessment._id)}} className='p-1 rounded bg-transparent hover:bg-vcm-light-purple hover:bg-opacity-20 transition duration-200 text-gray-400 hover:text-vcm-purple'>
                              <TrashIcon className={`w-5 h-5`} />
                            </button>
                          </div>
                        </div>
                      ))}
                    </div>
                    <Pagination 
                      pagination={{
                        perPage, 
                        page,
                        totalItems: assessmentsSelector?.assessments?.total,
                      }} 
                      changePage={setPage} 
                      updatePerPage={setPerPage}
                    />
                  </>
              </div>
              : 
              <div className='mt-24 w-1/2 mx-auto'>
                <EmptyState emptyStateText={`No assessments available yet`} />
              </div>
            }
          </>
        }
      </div>

      <ModalDialog
        shown={creatingAssessment} 
        closeFunction={()=>{setCreatingAssessment(false)}} 
        actionFunction={()=>{}} 
        actionFunctionLabel={``}
        dialogTitle='Create a new assessment'
        maxWidthClass='xl:max-w-xl 2xl:max-w-lg'
        hideActions={true}
      >
        <CreateAssessment 
          reload={()=>{setReload(reload+1)}}
          close={()=>{setCreatingAssessment(false)}}
        />
      </ModalDialog>
    </>
  )
}

export default Assessments